export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10005.dc5eb3e6.jpg";